export default __webpack_public_path__ + "static/media/aq-true_south.ee16afa7.svg";